import React from "react"
import { connect } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { Tooltip } from "@material-ui/core";
import {DEFAULT_TOOLTIP_PROPS} from "../../../helpers/tooltipHelper";
import translations from "../../../translations";

interface PropsType {
  title: string,
  language:string
}

const DynamicHeaderForm = (props: PropsType) => {
  const {
    title,
    language
  } = props;

  return (
    <div className="header-dynamic-form pb-4 pl-0">
      <h6 className="title-like section-title m-0 d-flex justify-content-between">
        <Tooltip {...DEFAULT_TOOLTIP_PROPS}
          title={translations('tooltipFilters',language)}
          placement="right-end"
        >
          <span className="title">
            {title}
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="ml-1"
            />
          </span>
        </Tooltip>
      </h6>
    </div>
  );
}

const mapStateToProps = (state) => ({
  language: state.application.appParameters.language
});

export default connect(mapStateToProps)(DynamicHeaderForm);
